var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgRemoveList = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.25,
    height: 18,
    viewBox: "0 0 20.25 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.684,30l-1.209-1.209,3.206-3.178-3.206-3.178,1.209-1.209,3.178,3.206,3.178-3.206,1.209,1.209-3.206,3.178,3.206,3.178L25.041,30l-3.178-3.206ZM6,22.969V21.281h8.438v1.688Zm0-4.641V16.641H19.219v1.688Zm0-4.641V12H19.219v1.688Z",
    transform: "translate(-6 -12)",
    fill: "#3b3b3b"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRemoveList, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/removeList.608e5132.svg";
export { ForwardRef as ReactComponent };